import {
    InputField,
    ListItem,
    Popup,
} from "@hatch-digital-nl/abs-storybook/legacy";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
    setIsPickEstablishmentModalOpen,
    setSearchTerm,
} from "./PickEstablishmentModalSlice";
import searchImage from "../../common/images/search.svg";
import { setActiveEstablishmentId } from "../../app/rootReducer";
import { useGetEstablishmentsQuery } from "../../common/api/establishment";
import { useEmployeeId } from "../../common/utils/useEmployeeId";
import { useGetEmployeeMeQuery } from "../../common/api/employee";
import { AbsLogo } from "../../common/svg/AbsLogo";
import Skeleton from "react-loading-skeleton";
import { useIsEstablishmentSet } from "../../common/utils/useIsEstablishmentSet";
import { debounce } from "../../common/utils/debounce";
import { JSX } from "react";
import { getUserFullName } from "../../common/utils/getUserFullName";

export const PickEstablishmentModalContainer = (): JSX.Element | null => {
    const dispatch = useAppDispatch();
    const { searchTerm } = useAppSelector(
        (state) => state.pickEstablishmentModal,
    );
    const isEstablishmentSet = useIsEstablishmentSet();
    const { data: employeeMeData } = useGetEmployeeMeQuery({});
    const {
        data: establishmentData,
        isLoading: establishmentDataIsLoading,
        isFetching: establishmentDataIsFetching,
    } = useGetEstablishmentsQuery({
        items_per_page: 9999,
        filter: {
            search: searchTerm,
            employee_id: useEmployeeId(),
        },
    });

    if (!employeeMeData) {
        return null;
    }

    return (
        <Popup
            className={"c-pick-establishment-modal"}
            showCloseButton={!!isEstablishmentSet}
            onCloseClick={() =>
                dispatch(setIsPickEstablishmentModalOpen(false))
            }
        >
            <div className={"c-pick-establishment-modal__header"}>
                <AbsLogo />
                <h2>{getUserFullName(employeeMeData.user)}</h2>
                <p>
                    Vanuit het dashboard kun je ook wisselen tussen vestigingen
                </p>

                <div className="c-pick-establishment-modal__header__search">
                    <InputField
                        iconRight={searchImage}
                        placeHolder={"Zoeken..."}
                        value={searchTerm}
                        onChange={debounce((value: string) => {
                            dispatch(setSearchTerm(value));
                        })}
                    />
                </div>
            </div>
            <div className={"c-pick-establishment-modal__container"}>
                <p>Selecteer vestiging</p>

                <div className={"c-pick-establishment-modal__container__list"}>
                    {establishmentDataIsLoading ||
                    establishmentDataIsFetching ||
                    !establishmentData ? (
                        <Skeleton
                            count={5}
                            height={"5rem"}
                            borderRadius={"0.8rem"}
                        />
                    ) : (
                        establishmentData.data.map((establishment) => {
                            const establishmentAddress = `${establishment.address.street} ${establishment.address.house_number}, ${establishment.address.zip_code} ${establishment.address.city}`;
                            return (
                                <ListItem
                                    key={establishment.id}
                                    establishment={{
                                        name: establishment.name,
                                        address: establishmentAddress,
                                    }}
                                    onClick={() => {
                                        dispatch(
                                            setActiveEstablishmentId(
                                                establishment.id,
                                            ),
                                        );
                                        dispatch(
                                            setIsPickEstablishmentModalOpen(
                                                false,
                                            ),
                                        );
                                    }}
                                />
                            );
                        })
                    )}
                </div>
            </div>
        </Popup>
    );
};
